import componentEnHK from './component/en-HK'
import pageEnHK from './page/en-HK'

const EnHK = {
  ...componentEnHK,
  ...pageEnHK
}

export default EnHK